import { css } from 'linaria';

export const fencesSubtypesSection = css`
  && {
    .swiper-wrapper {
      @media (--only-largeDesktop) {
        column-gap: 24px;
      }
    }

    .swiper {
      margin-bottom: 0;
    }
  }
`;

export const fencesProfnastilSubtypesSection = css`
  && {
    .swiper-wrapper {
      @media (--only-largeDesktop) {
        column-gap: 40px;
      }
    }
  }
`;

export const fencesSubtypesSectionTitle = css`
  && {
    margin-bottom: 24px;
  }
`;

export const fencesSubtypesCharacteristicsWrapper = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 24px 40px;
  margin-bottom: 32px;
  column-gap: 16px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  row-gap: 16px;

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 1fr);
    padding: 24px 16px;
    margin-right: -16px;
    margin-left: -16px;
    border-radius: 0;
  }
`;

export const fencesSubtypesCharacteristicsStylesMap: Record<number, string> = {
  4: css`
    @media (--from-desktop) {
      grid-template-columns: repeat(4, 1fr);
    }
  `,
};

export const fencesSubtypesCharacteristicName = css`
  margin-bottom: 4px;
`;

export const fencesSubtypesSectionImage = css`
  width: 144px;
  height: 144px;
  margin-bottom: 24px;
`;

export const fencesSubtypesItem = css`
  &&& {
    @media (--only-largeDesktop) {
      width: 277px;
    }

    @media (--only-desktop) {
      width: 205px;
    }

    @media (--only-tablet) {
      width: 193px;
    }

    @media (--only-mobile) {
      width: 204px;
    }
  }
`;

export const fencesProfnastilSubtypesItem = css`
  &&& {
    @media (--only-largeDesktop) {
      width: 163px;
    }
  }
`;

export const fencesSubtypesItemProperty = css`
  display: flex;
  column-gap: 4px;

  &:first-of-type {
    margin-top: 16px;
  }

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

export const fencesPanelnyeSubtypesItemProperty = css`
  @media (--to-desktop) {
    flex-direction: column;

    & p:first-of-type {
      margin-bottom: 4px;
    }
  }
`;

export const fencesModulnyeSubtypesItemProperty = css`
  @media (--to-desktop) {
    flex-direction: column;

    & p:first-of-type {
      margin-bottom: 4px;
    }
  }
`;

export const fencesSubtypesItemText = css`
  margin-top: 8px;
`;
